/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* PauseSchedulesRequest selects schedules under a report to pause. When schedule_ids is omitted or empty, all ACTIVE schedules on the report are paused. When schedule_ids is provided, all listed schedules must currently be in ACTIVE status; otherwise the call is all-or-nothing and no schedules are paused.
*/
export class AdvertisingPlatformServicePauseSchedulesRequest {
    /**
    * Owning organization.
    */
    'orgId': string;
    /**
    * IDs of schedules to pause. Optional. When omitted or empty, all ACTIVE schedules on the report are paused. When provided, every listed id must reference an ACTIVE schedule.
    */
    'scheduleIds'?: Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "scheduleIds",
            "baseName": "schedule_ids",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return AdvertisingPlatformServicePauseSchedulesRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

